module.exports = __webpack_public_path__ + "static/media/kakao-talk.a6eb9be2.svg";